import { getRequest, postRequest } from 'config/Axios/baseConfig';
import { LoginReponseInterface } from 'Interfaces/authInterface';
import { UserInfoInterface } from 'Interfaces/User/userInterfaces';

export const authServices = {
  getUserInfoAndRoles: (): Promise<UserInfoInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<UserInfoInterface>('auth/user-info');
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  initiateLogin: (): Promise<LoginReponseInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<LoginReponseInterface>('auth/initiate-login');
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getOktaLoginCode: (): Promise<oktaLoginCodesInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<oktaLoginCodesInterface>('auth/get-login-codes');
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  refreshToken: (refreshToken: string): Promise<{ access: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ access: string }>('auth/refresh', {
          refresh: refreshToken
        });
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  logout: (): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      try {
        await postRequest('auth/logout', {});
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
};
